import * as React from 'react';

type SortDirection = 'asc' | 'desc';

interface UseSortReturn {
  sortBy: string | undefined;
  sortDirection: SortDirection | undefined;
  handleSort: (field: string) => void;
}

export function useSort(): UseSortReturn {
  const [sortBy, setSortBy] = React.useState<string | undefined>(undefined);
  const [sortDirection, setSortDirection] = React.useState<SortDirection | undefined>(undefined);

  const handleSort = React.useCallback(
    (field: string) => {
      if (sortBy !== field) {
        setSortBy(field);
        setSortDirection('asc');
        return;
      }

      if (sortDirection === 'desc') {
        setSortBy(undefined);
        setSortDirection(undefined);
        return;
      }

      setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    },
    [sortBy, sortDirection],
  );

  return { sortBy, sortDirection, handleSort };
}
